import { Route } from '@angular/router';
import { getNavigationGroup } from '../../core/config/app-navigation';
import { pageAccessGuard } from '../../core/guards/page-access.guard';

const ayudaNavigation = getNavigationGroup('ayuda');
const ayudaItem = ayudaNavigation.items.find((item) => item.key === 'ayuda');

if (!ayudaItem) {
  throw new Error('No navigation item configured for "ayuda".');
}

export const ayudaRoutes: Route[] = [
  {
    path: ayudaItem.path.replace(/^\//, ''),
    data: {
      pageKey: ayudaItem.pageKey,
      title: ayudaItem.title,
      description: ayudaItem.description,
    },
    canActivate: [pageAccessGuard],
    loadComponent: () => import('./pages/ayuda/ayuda.page').then((m) => m.AyudaPage),
  },
];
